export const PAGE_PATH = '/admin-earning';
